export default {
    USER: "Автор",
    CREATED_DATE: "Создана",
    SOURCE_TASKS: "Методы",
    UNKNOWN: "Неизвестно",
    YOU: "Вы",
    STOP_TASK: "Остановить задачу",
    RELOAD_TASK: "Перезапустить задачу",
    WATCH_TASK_LOGS: "Посмотреть лог задания",
    HIGHLIGHT_RESULTS: "Подсветить результаты",
    TOOLTIP_SHOW_OBJECTS_COUNT: "Показать кол-во полученных объектов",
    TOOLTIP_HIDE_OBJECTS_COUNT: "Скрыть кол-во полученных объектов"
};
